<template>
  <div>
    <mu-content-block id="initialLoader" v-if="isLoading">
      <mu-circular-progress :size="32"></mu-circular-progress>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <mu-content-block id="initialLoader" v-if="isError">
      <span>Unauthorized to view article</span>
    </mu-content-block>
    <article id="LifeStyleArticle" v-if="(!isLoading && !isError)">
      <mu-row gutter v-if="(!isLoading && !isError)">
        <mu-col desktop="70" tablet="100" width="100">
          <mu-card v-if="post.post_video && post.post_format === 'video'" style="background:none;box-shadow:none;">
            <div id="embed-video" v-html="$sanitize(post.post_video_iframe, {allowedAttributes: {
                        'iframe': [ 'width', 'height', 'allow', 'frameborder', 'src', 'webkitallowfullscreen', 'mozallowfullscreen', 'allowfullscreen' ] }})"></div>
          </mu-card>
          <mu-card id="articleContent">
            <img class="postImg" v-if="post.post_image" :src="post.post_image" alt="">
            <div id="byAuthor">
              <div class="info">
                <mu-avatar :size="32" :src="post.post_author_image" />
                <p class="name" v-text="post.post_author"></p>
                <div class="date">
                  <mu-icon value="watch_later" color="#5b617c" />
                  <time :datetime="post.post_date" v-text="moment(post.post_date).fromNow()"></time>
                </div>
                <div class="favourites">
                  <mu-icon value="favorite" color="#d83e38" />
                  <span v-text="post.post_favourites"></span>
                </div>
              </div>
              <div class="favouriteBtn">
                <mu-flat-button
                  :icon="post.post_favourited ? 'favorite' : 'favorite_border'"
                  :label="post.post_favourited ? 'Favourited' : 'Favourite'"
                  @click="favouritePost()"
                />
              </div>
            </div>
            <h1 class="postTitle" v-html="post.post_title"></h1>
            <mu-row>
              <mu-col desktop="100" tablet="100" width="100">
                <mu-content-block>
                  <vue-markdown class="markdownContent" v-if="userId" :source="post.post_content">
                  </vue-markdown>
                  <div v-if="!userId" v-html="$sanitize(post.post_excerpt)"></div>
                  <div class="loggedOutActions" v-if="!userId">
                    <mu-raised-button primary label="Log in" @click="goToLogin" />
                    <mu-flat-button label="Register" @click="goToRoute('Register')" />
                  </div>
                </mu-content-block>
              </mu-col>
            </mu-row>
          </mu-card>
        </mu-col>
        <mu-col desktop="30" tablet="100" width="100">
          <div id="lifeSidebar">
            <!--<life-category-list v-if="isLoading === false" :postId="post.post_id" />-->
            <life-similar-posts v-if="isLoading === false && !isHcpView" :post_id="post.post_id" size="medium-400" />
          </div>
        </mu-col>
      </mu-row>
      <mu-row>
        <mu-col desktop="100" tablet="100" width="100">
          <life-comments v-if="userId" :postId="post.post_id" :userId="userId"></life-comments>
        </mu-col>
      </mu-row>
      <div id="lockScreen" v-if="isLoggedOut && !userId && attempts.read >= attempts.amount">
        <div id="lockModal">
          <mu-row>
            <mu-col width="100" tablet="100" desktop="50" class="desc">
              <mu-flexbox :gutter="0">
                <mu-flexbox-item>
                  <h2>Sorry to interrupt your reading, but...</h2>
                  <p>
                    We noticed that you’ve read {{attempts.read}} articles on the Low Carb Lifestyle blog this week.</p>
                  <p>Sign up for unlimited access to all this and loads more.</p>
                </mu-flexbox-item>
              </mu-flexbox>
            </mu-col>
            <mu-col width="100" tablet="100" desktop="50" class="noAccount">
              <mu-flexbox :gutter="0" align="center">
                <mu-flexbox-item>
                  <mu-raised-button class="signUpBtn" label="Sign up" @click.native="goToRoute('Register')" fullWidth/>
                  <p>{{$t('message.registerHaveAccount')}}
                    <a @click="goToLogin" v-text="$t('message.registerSignIn')">Sign in now</a>
                  </p>
                </mu-flexbox-item>
              </mu-flexbox>
            </mu-col>
          </mu-row>
        </div>
      </div>
    </article>
  </div>
</template>
<script>

  import TitleManager from '../../../helpers/TitleManager'

  import LifeStyleApi from '../../../api/LifeStyle/index';

  import LifeComments from "../../../components/LifeStyle/LifeComments/LifeComments";
  import LifeSimilarPosts from "../../../components/LifeStyle/LifeSimilarPosts/LifeSimilarPosts";
  import HcpMixin from '../../../mixins/HCPMixin';

  export default {
    components: {
      LifeSimilarPosts,
      LifeComments,
    },
    mixins: [
      HcpMixin
    ],
    name: 'life-detail',
    watch: {
      '$route': function () {
        let self = this;
        self.initMounted();
      }
    },
    data () {
      return {
        isLoggedOut: false,
        isError: false,
        isLocked: false,
        attempts: {
          amount: 3,
          read: parseInt(localStorage.getItem('lifeLock')) || 0
        },
        scroller: document.getElementsByClassName('main-content')[0],
        isLoading: true,
        articleUrl: "",
        post: {},
        stickyElement: {
          el: null,
          appHeaderHeight: null,
        }
      }
    },
    methods: {
      moment(date) {
        return moment(date);
      },
      getData () {
        let self = this,
          params = self.$route.params;
        if(self.$store.state.status.payment.paid === false) {
          self.goToRoute('LifeStyle');
        } else {
          LifeStyleApi.getPost(params.permalink, 'large').then((response) => {
            self.isLoading = false;
            self.post = response.data;
            TitleManager.setTitle(self.post.post_title);
            if(self.isHcpUser) {
              TitleManager.replaceTitle(self.post.post_title);
            }
            window.document.title = self.post.post_title + ' | LifeStyle';
            self.$gtag.pageview('/life/' + self.post.post_slug);
            self.$forceUpdate();
            if (self.userId) {
              // remove lock if logged in
              window.localStorage.removeItem('LifeLock');
            }
            self.$nextTick(function () {
              //If video apply 16:9 ratio
              $("iframe").wrap("<div class='video-container'/>")
              //Removes empty p tags
              $('p').each(function () {
                let $this = $(this);
                if ($this.html().replace(/\s|&nbsp;/g, '').length === 0)
                  $this.remove();
              });
              //Formats
              $('.wp-caption').each(function (i, e) {
                $(e).attr('style', '');
              });
            });
          }).catch((error) => {
            if (error) {
              if (error.response.status === 404) {
                TitleManager.setTitle('Article not found');
                self.isError = true;
                self.goToRoute('404');
              }
            }
            if (error.response.status === 403) {
              TitleManager.setTitle('Unauthorized');
              self.isError = true;
              self.isLoading = false;
            }
          });
        }
      },
      favouritePost() {
        let self = this;
        LifeStyleApi.favouritePost({
          post_id: self.post.post_id
        }).then((res) => {
          const callback = res.data;
          if (callback.fav_status) {
            self.post.post_favourited = true;
            self.post.post_favourites += 1;
          } else {
            self.post.post_favourited = false;
            self.post.post_favourites -= 1;
          }
        });
      },
      getArticleUrl() {
        let self = this;
        self.articleUrl = window.location.href;
      },
      goToRoute(name) {
        let self = this;
        self.$router.push({
          name: name
        })
      },
      goToLogin() {
        let self = this;
        self.$router.push({
          path: `/login?redirect=life/${self.post.post_slug}`
        })
      },
      initMounted() {
        let self = this, params = self.$route.params;
        TitleManager.setTitle(self.$t('message.loadingText'));
        if(self.isHcpUser) {
          TitleManager.replaceTitle(self.$t('message.loadingText'));
        }
        self.post = [];
        self.isLoading = true;
        setTimeout(() => {
          self.getData();
          setTimeout(function() {
            if (self.userId) {
              self.isLoggedOut = false;
              localStorage.removeItem('lifeLock');
            } else {
              self.isLoggedOut = true;
              if(!self.userId) {
                if( self.attempts.read !== self.attempts.amount ) {
                  if( self.isLoggedOut === true ) {
                    let count = parseInt(self.attempts.read);
                    localStorage.setItem('lifeLock',  count + 1);
                  }
                }
              } else {
                localStorage.removeItem('lifeLock');
              }
            }
          }, 1000);
        }, 1000);
        self.getArticleUrl();
      }
    },
    computed: {
      userId() {
        let self = this;
        if (_.has(self.$store.state.user, 'scope')) {
          return self.$store.state.user.scope.user_id;
        }
        return false;
      },
    },
    mounted () {
      let self = this;
      self.initMounted();
    }
  }
</script>
<style lang="less">
 @import "./life-article.less";

  @media print {
    figure#embed {
      display: none;
    }
    #app {
      .mu-paper {
        display: none;
      }
      .sidebarOpen {
        padding-left: 0;
        .mu-appbar {
          display: none;
        }
        #LifeStyleDetail {
          width: 100%!important;
          #LifeStyleArticle {
            .content {
              .col {
                width: 100%!important;
                &.desktop-30 {
                  display: none;
                }
                &.desktop-70 {
                  #articleContent + div {
                    display: none;
                  }
                  #articleContent {
                    p, ul li, ol li {
                      font-size: 15pt;
                      strong {
                        font-size: 18pt!important;
                      }
                    }
                    h3 {
                      font-size: 18pt!important;
                      strong {
                        font-size: 18pt!important;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// LifeArticle.vue?d19048ea